import React from "react";
import { useNavigate } from "react-router-dom";
import {
  AppstoreOutlined,
  EnvironmentOutlined,
  FilePdfOutlined,
  IdcardOutlined,
  LinkOutlined,
  MailOutlined,
  MessageOutlined,
  PictureOutlined,
  TagOutlined,
} from "@ant-design/icons";

const QR_TYPE_TABS = [
  { type: "Website QR", label: "Website", icon: <LinkOutlined />, publicPath: "/qr-link", dashboardPath: "/dashboard/qr-link" },
  { type: "Text QR", label: "Text", icon: <MessageOutlined />, publicPath: "/qr-text", dashboardPath: "/dashboard/qr-text" },
  { type: "Location QR", label: "Location", icon: <EnvironmentOutlined />, publicPath: "/qr-location", dashboardPath: "/dashboard/qr-location" },
  { type: "Brand QR", label: "Brand", icon: <PictureOutlined />, publicPath: "/qr-brand", dashboardPath: "/dashboard/qr-brand" },
  { type: "Social QR", label: "Social", icon: <AppstoreOutlined />, publicPath: "/qr-social", dashboardPath: "/dashboard/qr-social" },
  { type: "File QR", label: "File", icon: <FilePdfOutlined />, publicPath: "/qr-file", dashboardPath: "/dashboard/qr-file" },
  { type: "vCard QR", label: "vCard", icon: <IdcardOutlined />, publicPath: "/qr-vcard", dashboardPath: "/dashboard/qr-vcard" },
  { type: "Product QR", label: "Product", icon: <TagOutlined />, publicPath: "/qr-product", dashboardPath: "/dashboard/qr-product" },
  { type: "Message QR", label: "Message", icon: <MailOutlined />, publicPath: "/qr-message", dashboardPath: "/dashboard/qr-message" },
];

const QRTypeTabs = ({ activeType }) => {
  const navigate = useNavigate();
  const isModule = window.location.pathname.includes("/dashboard/");

  return (
    <div className="qr-type-tabs" aria-label="QR Code Type">
      {QR_TYPE_TABS.map((tab) => {
        const path = isModule ? tab.dashboardPath : tab.publicPath;
        const isAvailable = Boolean(path);
        const isActive = tab.type === activeType;

        return (
          <button
            key={tab.label}
            type="button"
            className={`qr-type-tab ${isActive ? "active" : ""}`}
            onClick={() => isAvailable && navigate(path)}
            disabled={!isAvailable}
            title={isAvailable ? tab.label : `${tab.label} coming soon`}
          >
            <span className="qr-type-icon">{tab.icon}</span>
            <span>{tab.label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default QRTypeTabs;
